import { FULL_PAGE_LOADING, RESET_FULL_PAGE_LOADING } from '../actions/types';

const initialState = {
  fullPageLoading: false,
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case FULL_PAGE_LOADING:
      return {
        ...state,
        fullPageLoading: true,
      };
    case RESET_FULL_PAGE_LOADING:
      return {
        ...state,
        fullPageLoading: false,
      };
    default:
      return state;
  }
}

export default reducer;
